import React, { Component } from 'react';
import { FocusTrap as FocusTrapReact, type FocusTrapProps } from 'focus-trap-react';

interface FocusTrapState {
  hasError: boolean;
}

class FocusTrap extends Component<FocusTrapProps, FocusTrapState> {
  constructor(props: FocusTrapProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): FocusTrapState {
    return { hasError: true };
  }

  render(): React.ReactNode {
    const { children, ...focusTrapProps } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return children;
    }

    return <FocusTrapReact {...focusTrapProps}>{children}</FocusTrapReact>;
  }
}

export default FocusTrap;
